// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Produto } from '../almoxarifado/produto.model';
import { Orgao } from '../comum/orgao.model';
import { Favorecido } from './favorecido.model';

export class FavorecidoProduto extends BaseResourceModel {
    constructor(
        public id?: number,
        public produto?: Produto,
        public favorecido?: Favorecido,
        public editavel?: boolean,
        public orgao?: Orgao
    ) {
        super();
    }
    static converteJson(json: any): FavorecidoProduto {
        return Object.assign(new FavorecidoProduto(), json);
    }
}
